<div class="mx-auto sm:py-6 py-4" [ngClass]="{
    'max-w-7xl': notificationList.length === 0,
    'max-w-full': notificationList.length,
}">
    <div class="grid grid-cols-12  h-[calc(100vh-120px)]">
        <div [ngClass]="{
            'col-span-12': notificationList.length === 0,
           'col-span-12 xl:col-span-4 md:col-span-5 md:order-1 order-2 md:mt-0 mt-6': notificationList.length > 0
        }" class="flex flex-col min-h-0">

            <!-- Main Content -->
            <div class="rtl:pl-1 ltr:pr-1 flex flex-col min-h-0" [ngClass]="{
    'border-[#DAE1E4] rtl:border-r-0 rtl:md:border-l md:border-r': notificationList.length
  }">

                <!-- Tabs -->
                <div class="sm:px-6 px-4">
                    <div class="tabs-container">
                        <button *ngFor="let type of tabsList" (click)="selectTab(type)" class="w-1/2 tab"
                            [ngClass]="selectedTab == type ? 'tab-active' : 'text-generic'">
                            {{(type === 'Transactions' ? 'NOTIFICATION.TRANSACTIONS' : 'NOTIFICATION.UPDATES') |
                            translate}}
                        </button>
                    </div>          
                </div>

                <!-- transaction list -->
                 <div class="flex-1 mt-6 overflow-y-auto sm:px-6 px-4 min-h-0" *ngIf="notificationList.length">
                    <div *ngFor="let group of filteredNotificationList; let i = index" class="mb-8">

                        <!-- Section Header -->
                        <div class="flex justify-between items-center mb-6">
                            <p class="text-base text-(--text-muted) font-medium leading-6">
                                {{ group.dateLabel }}
                            </p>
                            <p class="click-text" *ngIf="i === 0">{{'NOTIFICATION.MARK_ALL_READ' | translate}}</p>
                        </div>


                        <!-- Items -->
                        <div *ngFor="let tx of group.notifications" (click)="selectNotification(tx)"
                            class="flex justify-between sm:items-center bg-white rounded-3xl p-4 mb-4 sm:flex-row flex-col gap-3"
                            [ngClass]="{
       'bg-[#B9E2FF]': activeNotification === tx,
       'bg-white': activeNotification !== tx
     }">

                            <div class="flex items-center gap-4">
                                <div class="w-2 h-2 flex items-center justify-center rounded-full text-generic shrink-0"
                                    [ngClass]="{
                                        'bg-(--color-error)': tx.status === 'unread',
                                        'bg-transparent': tx.status === 'read',
                                    }">

                                </div>
                                <div>
                                    <p class="text-medium mb-1">{{ tx.title }}</p>
                                    <p class="text-xs text-(--text-secondary) font-medium line-clamp-1">{{
                                        tx.description }}</p>
                                </div>
                            </div>
                            <div class="font-medium text-xs shrink-0 sm:ml-0 ltr:ml-6 rtl:sm:mr-0 rtl:mr-6" [ngClass]="{
       'bg-[#B9E2FF]': activeNotification === tx,
       'text-(--text-placeholder)': activeNotification !== tx
     }">
                                {{tx.time}}
                            </div>
                        </div>
                    </div>
                </div>


                <!-- No Notifications -->
                <div class="flex flex-col items-center mt-10" *ngIf="notificationList.length === 0">
                    <img src="assets/icons/notification-bell.svg" class="w-14 h-14 mb-3" />
                    <p class="text-generic mb-1">{{'NO_NOTIFICATION' | translate}}</p>
                    <p class="text-base font-medium text-(--text-muted) mb-8 text-center">
                        {{'NO_NOTIFICATION_DESC' | translate}}
                    </p>
                </div>

            </div>
        </div>

        <!-- Right panel -->
        <div class="xl:col-span-8 md:col-span-7 col-span-12 flex flex-col md:gap-10 gap-4 sm:px-6 px-4 md:order-2 order-1 md:border-b-0 border-b md:pb-0 pb-8 border-[#DAE1E4]"
            *ngIf="filteredNotificationList.length && activeNotification">

            <div class="flex justify-between lg:gap-14 sm:gap-10 gap-2 min-h-20">
                <p class="text-(--text-primary) lg:text-2xl sm:text-xl text-lg font-semibold leading-8">
                    <span *ngIf="activeNotification.type !== 'updates'">{{ activeNotification.title }} – </span> {{
                    activeNotification.description }}
                </p>

                <button
                    class="shrink-0 text-(--color-error) font-medium text-base flex gap-2 cursor-pointer hover:opacity-86">
                    <img src="assets/icons/bin.svg" class="w-5 h-5" /> {{'NOTIFICATION.DELETE' | translate}}
                </button>
            </div>

            <div>
                <p class="text-base text-(--text-muted) font-medium">
                    {{ activeNotification.date }}
                </p>
                <p class="mt-3 text-medium">
                    {{ activeNotification.details }}
                </p>
            </div>
        </div>

    </div>


</div>